import { createContext, useContext } from "react"

export const WizardContext = createContext(null)

export const useWizardContext = () => {
  const ctx = useContext(WizardContext)
  if (!ctx) throw new Error("useWizardContext must be used inside WizardProvider")
  return ctx
}
